import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="xApp" style={{width: "100%", height: "100%"}}></div>
  );
}

export default App;
